@if (loading()) {
    <app-loader [isLoading]="loading()"></app-loader>
}
<div class="p-relative flex justify-between">
    <h4 mat-dialog-title>Загрузка заявок</h4>
    <app-close-button [formGroup]="form" [dialogRef]='dialogRef'/>
</div>
<mat-dialog-content class="upload-container" data-testid="upload-csv-dialog">
    <form [formGroup]="form" class="flex-column">
<!--Добавить когда нужен будет админ <app-common-dropdown [formCtrl]="companyControl" [label]="'Выбор компании'" [service]="companySelectorService"/>-->
        <app-time-zone/>
        <app-common-dropdown [label]="'Проект'" [service]="projectSelectorService" [formCtrl]="projectControl" data-testid="app-dropdown-project-upload-csv"/>
        <button
            mat-flat-button
            color="primary"
            (click)="uploadFile(fileInput)"
            [disabled]="form.invalid"
            data-testid="upload-file-csv-button"
        >Загрузить CSV</button>
        <input #fileInput type="file" accept=".csv" (change)="onFileSelected($event)" hidden data-testid="upload-csv-input"/>
    </form>
</mat-dialog-content>
